export * from '../constants-generated';
export const SKELETON_CLASS = 'skeleton';